import React, { useEffect, useState } from "react";

import { Link, useNavigate, useLocation } from "react-router-dom";
import { ClickAwayListener, IconButton } from "@mui/material";
import { DotsNine } from "phosphor-react";
import { Toaster, toast } from "react-hot-toast";
import {
  AppBar,
  Box,
  FormControlLabel,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Radio,
  RadioGroup,
  Toolbar,
  Typography,
} from "@mui/material";

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Fade from "@mui/material/Fade";
import SidePanel from "../common/sidePanel";

import {
  logout,
  changeLanguagePreference,
  getVdsProfile,
} from "../services/user/UserServices";
import { getStatusQuo } from "../services/yourWishes";
import { SecondaryButton } from "../common/Buttons";
import { getKeyFromText, getUserIdFromLocalStorage } from "../utils/Utilities";

import "./components.scss";

import { useTranslation } from "react-i18next";
import i18next from "i18next";
import { KeyboardArrowDown } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { allowedUsers, LANGUAGE } from "../constants/constants";
import { switchLanguage } from "../redux/slices/LanguageChange";
import { fetchTranslationsList } from "../redux/slices/TranslationSlice";

const LogOutDropDown = () => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const navigate = useNavigate();
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleLogout = async () => {
    let role = localStorage.getItem("role");
    const result = await logout();
    if (result?.success) {
      localStorage.clear();
      if (role == "#EC") {
        window.location = "/admin";
      } else {
        window.location = "/login";
      }
      handleClose();
    }
  };

  const navigateToSetting = async () => {
    navigate("/Setting");
    handleClose();
  };

  return (
    <>
      <div>
        <IconButton
          sx={{
            cursor: "pointer",
          }}
          aria-label="logout menu"
          size="small"
          aria-controls={open ? "fade-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
        >
          <KeyboardArrowDown
            sx={{
              color: "black",
            }}
          />
        </IconButton>
      </div>
      <Menu
        PaperProps={{
          elevation: 2,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.09))",
            mt: 3.8,
            borderRadius: "10px",
          },
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        id="fade-menu"
        MenuListProps={{
          "aria-labelledby": "fade-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
      >
        <MenuItem onClick={navigateToSetting}>{t("Setting")}</MenuItem>
        <MenuItem
          onClick={() => {
            handleLogout();
          }}
        >
          {t("logout")}
        </MenuItem>
      </Menu>
    </>
  );
};

const LangChanger = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const location = useLocation();

  const dispatch = useDispatch();

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const languageChanger = async (event) => {
    let key = event.target.value;
    i18next.changeLanguage(key);
    dispatch(switchLanguage());
    localStorage.setItem("LanguagePreference", JSON.stringify(key));
    handleClose();
    const auth = JSON.parse(localStorage.getItem("auth"));
    dispatch(fetchTranslationsList("All"));
    if (auth) {
      await changeLanguagePreference(key);
    }
  };
  return (
    <div
      style={{
        marginLeft: location.pathname.includes("not-allowed") && "2rem",
        marginTop: "6px",
      }}
    >
      <Box display="flex" marginLeft="10px">
        <label
          className="header-text"
          style={{
            textTransform: "uppercase",
            cursor: "pointer",
            fontWeight: "bold",
          }}
        >
          {i18next.language}
        </label>

        <IconButton
          sx={{
            cursor: "pointer",
            marginTop: "-5px",
          }}
          aria-label="logout menu"
          size="small"
          aria-controls={open ? "fade-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
        >
          <KeyboardArrowDown
            sx={{
              color: "black",
            }}
          />
        </IconButton>
      </Box>
      <Menu
        PaperProps={{
          elevation: 2,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.09))",
            mt: 2,
            borderRadius: "10px",
          },
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        id="fade-menu"
        MenuListProps={{
          "aria-labelledby": "fade-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
      >
        <RadioGroup
          className="radio-nav"
          aria-labelledby="demo-radio-buttons-group-label"
          defaultValue="female"
          name="radio-buttons-group"
          onChange={languageChanger}
          value={i18next.language}
          sx={{
            paddingLeft: "1rem",
          }}
        >
          <FormControlLabel value="de" control={<Radio />} label="Deutsch" />
          <FormControlLabel value="en" control={<Radio />} label="English" />
        </RadioGroup>
      </Menu>
    </div>
  );
};

const Navbar = () => {
  const { t, i18n } = useTranslation();

  const currentLanguage = i18n.language;

  const navigate = useNavigate();
  const location = useLocation();
  let uID = getUserIdFromLocalStorage();
  const user = useSelector((state) => state.user);

  const fetchUserWish = async () => {
    let check = false;
    const restult = await getStatusQuo(uID);
    if (restult.payLoad?.length) {
      check = restult.payLoad.some((element) => element.isWishChecked);
    }
    return check;
  };

  const getUser = () => {
    if (localStorage.getItem("token") || localStorage.getItem("auth")) {
      return (
        <>
          <Box display="flex" alignItems="center">
            <Typography
              variant="h6"
              paddingRight={2}
              sx={{ fontSize: "20px", fontWeight: "700" }}
            >
              {localStorage.getItem("userName")}
            </Typography>
            <img
              src="/assets/icons/account-circle.png"
              width={25}
              style={{
                cursor: "pointer",
              }}
              alt="account"
            />
            <LogOutDropDown />
          </Box>
        </>
      );
    }
  };
  const getGridWidth = () => {
    const isAllowedUser1 = allowedUsers[0] === user?.role?.roleName;
    const isAllowedUser2 = allowedUsers[1] === user?.role?.roleName;

    if (isAllowedUser1) {
      return currentLanguage === LANGUAGE.en ? 8 : 9;
    } else if (isAllowedUser2) {
      return 5;
    } else {
      return 6;
    }
  };

  const getGridJustification = () => {
    return localStorage.getItem("auth") ? "space-between" : "flex-end";
  };
  const getGridLgValue = () => {
    const isAllowedUser0 = allowedUsers[0] === user?.role?.roleName;
    const isAllowedUser1 = allowedUsers[1] === user?.role?.roleName;

    if (isAllowedUser1) {
      return 4;
    } else if (isAllowedUser0) {
      return currentLanguage === LANGUAGE.en ? 1 : 0;
    } else {
      return 3;
    }
  };

  const getGridMdValue = () => {
    return currentLanguage === LANGUAGE.en ? 1 : 0;
  };
  return (
    <>
      <Toaster />
      <AppBar
        position="sticky"
        sx={{
          bgcolor: "color.white",
          color: "color.black",
          boxShadow: "0px 2px 12px 2px rgb(0 0 0 / 7%)",
        }}
      >
        <Box style={{ position: "relative" }}>
          <Toolbar>
            <Grid container>
              <Grid item xs={0} md={1}></Grid>
              <Grid item sm={3} md={2}>
                <Box component="div">
                  <Box
                    className="header-logo"
                    component="img"
                    alt="Company Logo"
                    src="/assets/icons/brand.png"
                    sx={{
                      cursor: "pointer",
                      width: "72px",
                      filter: "contrast(2)",
                      margin: "0.5rem 0",
                      marginLeft: "40px",
                    }}
                    onClick={() => {
                      navigate("/");
                    }}
                  />
                </Box>
              </Grid>

              <Grid
                item
                xs={0}
                md={getGridMdValue()}
                lg={getGridLgValue()}
              ></Grid>

              <Grid
                item
                sm={9}
                md={7}
                lg={getGridWidth()}
                display="flex"
                alignItems="center"
                justifyContent={getGridJustification()}
                className="nav-links"
                width="100%"
              >
                {localStorage.getItem("auth") ? (
                  <>
                    {localStorage.getItem("menuStructure") ? (
                      JSON.parse(localStorage.getItem("menuStructure"))?.map(
                        (item) => {
                          return (
                            <p
                              style={{
                                pointerEvents:
                                  location.pathname.includes(item.to) && "none",
                                fontSize: "16px",
                                marginRight:
                                  currentLanguage === LANGUAGE.en
                                    ? "2.7rem"
                                    : "1rem",
                              }}
                              onClick={async () => {
                                if (item.route === "/documents") {
                                  if (await fetchUserWish())
                                    navigate(item.route);
                                  else toast.error(t("select-wishes"));
                                } else {
                                  navigate(item.route);
                                }
                              }}
                              key={item.id}
                              className={`${
                                location.pathname.includes(item.route) &&
                                "active"
                              }`}
                            >
                              {t(getKeyFromText(item.componentName))}
                            </p>
                          );
                        }
                      )
                    ) : (
                      <div></div>
                    )}
                    {localStorage.getItem("menuStructure") ? (
                      <p
                        style={{
                          pointerEvents:
                            location.pathname.includes("/team") && "none",
                          fontSize: "1.125rem",
                        }}
                        onClick={async () => {
                          navigate("/team");
                        }}
                        key={"teams-123"}
                        className={`${
                          location.pathname.includes("/team") && "active"
                        }`}
                      >
                        {t("navbar1-text-2")}
                      </p>
                    ) : (
                      <div></div>
                    )}
                  </>
                ) : (
                  !location.pathname.includes("register") && (
                    <>
                      <Link className="header-text" to="/about">
                        {t("navbar1-text-1")}
                      </Link>
                    </>
                  )
                )}
                {getUser()}

                <LangChanger />
              </Grid>
            </Grid>
          </Toolbar>
        </Box>
      </AppBar>
    </>
  );
};

export default Navbar;
